import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

function LoadingCardFragments() {
  return (
    <FixaSkeleton
      data-testid={"loading-fragment"}
      width="100%"
      height="46.5px"
    />
  );
}

export default LoadingCardFragments;
